import { useRecoilValue } from 'recoil';
import { useAuthorization } from '../../../authorization/useAuthorization';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { ACCESS } from '../../../constants/authz/accessPresets.constants';
import { globalpermissions } from '../../../Services/Permission';
import { userInformationAtom } from '../../../Services/_states';

/**
 * Intervene module permissions — RBAC v2 feature grants with legacy fallback.
 */
export default function useIntervenePermissions() {
  const { can, isAuthzV2Enabled } = useAuthorization();
  const userInfo = useRecoilValue(userInformationAtom);
  const constActions = ConstantActions();

  if (isAuthzV2Enabled) {
    return {
      canAccessModule: can(ACCESS.INTERVENE_VIEW),
      canUseChat: can(ACCESS.INTERVENE_CHAT),
      canUseCalling: can(ACCESS.INTERVENE_CALLING),
      currentUserId: userInfo?.id ?? null,
    };
  }

  const permissions = userInfo?.profile?.permissions || {};
  const hasDashboard = constActions.userHasPermission([
    globalpermissions.pagePermissions.interveneNew,
  ]);
  const hasLiveChat = Boolean(permissions[globalpermissions.interveneChat.interveneChat]);

  return {
    canAccessModule: hasDashboard,
    canUseChat: hasLiveChat,
    canUseCalling: hasDashboard,
    currentUserId: userInfo?.id ?? null,
  };
}
